import ShareFormModal from 'routes/Forms/ShareFormModal/ShareFormModal';

export default ShareFormModal;
